export class AnalyticActivityModel {
    [id: string]: string;
    engine_version: string;
    api_version: string;
}

export class AnalyticUserActivityModel extends AnalyticActivityModel {
    parent_analytic_identifier: string;
    referer_domain: string;
}
